import { useCallback, useMemo, useState } from "react";

export interface PickerModeConfig {
  title: string;
  subtitle: string;
  showTemplateName: boolean;
  foldersSelectable: boolean;
  showViewToggle: boolean;
  showUploadButton: boolean;
  showMagicButton: boolean;
  confirmLabel: (selectedCount: number) => string;
}

export interface PickerFilters {
  classifications: string[];
  investors: number[];
  effectiveDate: string | null;
}

const defaultFilters: PickerFilters = { classifications: [], investors: [], effectiveDate: null };

export const usePickerFilters = () => {
  const [filters, setFilters] = useState<PickerFilters>(defaultFilters);

  const hasActiveFilters = useMemo(
    () => filters.classifications.length > 0 || filters.investors.length > 0 || filters.effectiveDate !== null,
    [filters]
  );

  const setClassifications = useCallback((values: string[]) => {
    setFilters((prev) => ({ ...prev, classifications: values }));
  }, []);

  const setInvestors = useCallback((values: number[]) => {
    setFilters((prev) => ({ ...prev, investors: values }));
  }, []);

  const setEffectiveDate = useCallback((value: string | null) => {
    setFilters((prev) => ({ ...prev, effectiveDate: value }));
  }, []);

  const clearFilter = useCallback((key: keyof PickerFilters) => {
    setFilters((prev) => ({ ...prev, [key]: key === "effectiveDate" ? null : [] }));
  }, []);

  const clearAllFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, []);

  return {
    filters,
    hasActiveFilters,
    setClassifications,
    setInvestors,
    setEffectiveDate,
    clearFilter,
    clearAllFilters,
    resetFilters
  };
};
